import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TNotificationItem, TNotificationState } from './notifications.types';

const initialState: TNotificationState = {
  notification: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    pushNotification: (state, action: PayloadAction<TNotificationItem>) => {
      state.notification = action.payload;
    },
    dismissNotification: (state) => {
      state.notification = null;
    },
  },
});

export const { pushNotification, dismissNotification } =
  notificationsSlice.actions;

export const notificationsReducer = notificationsSlice.reducer;
